module.exports = __webpack_public_path__ + "fonts/sms_38x38.4661fd6ccaded3a68b1803ac32b26592.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/sms_38x38.png
// module id = 785
// module chunks = 9